import { createAction, props } from "@ngrx/store";
import { Weight, WeightFirebaseResponse } from "../../models/weights.model";
import { User } from "../../models/user.model";

export const LOAD_WEIGHT = '[Weight] Load weight';
export const LOAD_WEIGHT_SUCCESS = '[Weight] Load weight success';
export const LOAD_WEIGHT_FAIL = '[Weight] Load weight fail';
export const ADD_WEIGHT = '[Weight] Add weight';
export const ADD_WEIGHT_SUCCESS = '[Weight] Add weight success';
export const ADD_WEIGHT_FAIL = '[Weight] Add weight fail';
export const UPDATE_WEIGHT = '[Weight] Update weight';
export const UPDATE_WEIGHT_SUCCESS = '[Weight] Update weight success';
export const UPDATE_WEIGHT_FAIL = '[Weight] Update weight fail';

export const LoadWeightAction = createAction(
    LOAD_WEIGHT,
    props<{ data: User }>()
);

export const LoadWeightSuccessAction = createAction(
    LOAD_WEIGHT_SUCCESS,
    props<{ data: WeightFirebaseResponse }>()
);

export const LoadWeightFailAction = createAction(
    LOAD_WEIGHT_FAIL,
    props<{ error: Error }>()
);

export const AddWeightAction = createAction(
    ADD_WEIGHT,
    props<{ data: WeightFirebaseResponse; user: User }>()
);

export const AddWeightSuccessAction = createAction(
    ADD_WEIGHT_SUCCESS,
    props<{ data: WeightFirebaseResponse }>()
);

export const AddWeightFailAction = createAction(
    ADD_WEIGHT_FAIL,
    props<{ error: Error }>()
);

export const UpdateWeightAction = createAction(
    UPDATE_WEIGHT,
    props<{ data: WeightFirebaseResponse; user: User }>()
);

export const UpdateWeightSuccessAction = createAction(
    UPDATE_WEIGHT_SUCCESS,
    props<{ data: WeightFirebaseResponse }>()
);

export const UpdateWeightFailAction = createAction(
    UPDATE_WEIGHT_FAIL,
    props<{ error: Error }>()
);
